import React  from 'react';
function SilverZakatTable({ result }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Zakat Obligation</td>
          <td>{result.silverZakatDuty === 'yes' ? 'You are obligated to pay Zakat' : 'You are not obligated to pay Zakat'}</td>
        </tr>
        <tr>
          <td>Silver Zakat Threshold</td>
          <td>{result.silverWeightThreshold} (g)</td>
        </tr>
        <tr>
          <td>Amount of Zakat Obligatory to Be Paid (from Money)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
        <tr>
          <td>Amount of Zakat Obligatory to Be Paid (from Silver)</td>
          <td>{result.silverZakatAmount} (g)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default SilverZakatTable;
